if (typeof Vue != "undefined" && typeof $medportal != "undefined") {
    var $mainMenuVue = new Vue({
        el: '#header-wrapper',
        name: "menuToolbar",
        data: {
            profile: {
                data: $medportal
            },
            body: null,
            isDesignMode: false,
            tooltip: null,
            mobileAppMenu: null,
            routes: {
                favourites: "/RestApi/favorites",
                homepage: "/RestApi/layout/homepage"
            },
            search: {
                term: ""
            }
        },
        mounted: function () {
            this.body = $("body");
            this.isDesignMode = isInDesignMode();
        },
        methods: {
            openProfileMenu: function (e) {
                e.preventDefault();
                var _this = this;
                if (!this.IsDesignMode) {
                    var link = $(e.currentTarget);
                    if (this.tooltip == null) {
                        this.tooltip = link.kendoTooltip({
                            content: kendo.template(this.getPopupTemplate()),
                            autoHide: false,
                            showOn: "click",
                            position: "bottom",
                            width: $(window).width() <= 500 ? 400 : 300,
                            show: function () {
                                //Init favourites
                                _this.loadFavourites();
                            },
                            hide: function () {
                            }
                        }).data("kendoTooltip");

                        this.tooltip.show(link);
                        this.tooltip.popup.element.addClass('profile-dropdown');
                        sendGATagTrackingEvent("Toolbar", "Profile Menu", "Open");
                    }
                }

                //Check for homepage
                this.isHomepage();
            },
            openMobileAppsMenu: function () {
                try {
                    //Create the mobile menu from the existing menu...only if it doesnt exist
                    var body = this.body;
                    if (this.mobileAppMenu === null) {
                        var serviceItems = {
                            Data: []
                        };
                        $("#header-icons a").each(function () {
                            if (!$(this).hasClass("hide-in-apps-menu")) {
                                var item = {
                                    Name: $(this).attr("data-name"),
                                    Url: $(this).attr("href"),
                                    Icon: $(this).find("i").get(0).outerHTML,
                                    Notification: null
                                };
                                var attr = $(this)[0].hasAttribute("data-notification-key");
                                if (attr) {
                                    item.Notification = attr;
                                }
                                serviceItems.Data.push(item);
                            }
                        });
                        console.log(serviceItems);
                        var template = kendo.template(this.getMobileMenuTemplate());
                        body.append(template(serviceItems.Data));
                        this.mobileAppMenu = $("#mobile-apps-menu-popup");
                    }
                    //this.mobileAppMenu.width($(document).width());
                    //inform the body of the state change
                    body.addClass("mobile-apps-open");
                    $('<div id="mobile-backdrop" class="modal-backdrop fade in"></div>').appendTo(document.body);
                    setTimeout(function () {
                        //Add notification dots, give help time to render
                        lookForNotificationDots();
                    }, 200);
                    sendGATagTrackingEvent("Toolbar", "Profile Menu", "Open", "Mobile");
                }
                catch (e) {
                    if (Raygun)
                        Raygun.send(e);
                }
            },
            closeMobileAppMenu: function () {
                this.body.removeClass("mobile-apps-open");
                this.body.find("#mobile-backdrop").remove();

                sendGATagTrackingEvent("Toolbar", "Profile Menu", "Close", "Mobile");
            },
            removeHomepage: function (e) {
                e.preventDefault();
                var _this = this;
                axios.delete(this.routes.homepage).then(function (result) {
                    console.log(result);
                    _this.changeHomepageLink("add");
                });
            },
            isHomepage: function () {
                var _this = this;
                var pageUrl = window.location.href.replace("https://", "").replace(window.location.host, "");
                axios.get(this.routes.homepage).then(function (result) {
                    console.log("Is Homepage", result);
                    if (result.status == 200) {
                        if (pageUrl == result.data) {
                            _this.changeHomepageLink("remove");
                        }
                    }
                });
            },
            makeHomepage: function (e) {
                if (e) {
                    e.preventDefault();
                }

                var _this = this;
                var pageUrl = window.location.href;

                var data = {
                    HomepageUrl: pageUrl
                };

                axios.post(this.routes.homepage, data).then(function (result) {
                    console.log(result);
                    _this.changeHomepageLink("remove");
                });
            },
            changeHomepageLink(type) {
                var link = $("#homepageLink");
                if (type == "remove") {
                    link.html("<i class='fal fa-fw fa-house'></i> Remove this as my Homepage");
                    link.attr("onclick", "$mainMenuVue.removeHomepage(event);");
                } else if (type == "add") {
                    link.html("<i class='fal fa-fw fa-house'></i>Make this my Homepage");
                    link.attr("onclick", "$mainMenuVue.makeHomepage(event);");
                }
            },
            addFavourite: function () {
                var _this = this;
                var pageName = document.title;
                var pageUrl = window.location.href;
                sendGATagTrackingEvent("Toolbar", "Profile Menu", "Add Favorite", pageUrl);

                var data = {
                    PageName: pageName,
                    Url: pageUrl
                };

                axios.put(this.routes.favourites, data).then(function () {
                    _this.loadFavourites();
                });
            },
            loadFavourites: function () {
                var _this = this;
                var pageName = document.title;
                var pageUrl = window.location.href;

                var params = {
                    PageName: pageName,
                    Url: pageUrl
                };

                axios.get(this.routes.favourites, params).then(function (data) {
                    var template = kendo.template(_this.getFavoriteTemplate());
                    var favsHtml = template(data.data);
                    var isCurrentPageFav = false;
                    //Check if this page is in results
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].Url == pageUrl) {
                            //Already exists, hide add button
                            isCurrentPageFav = true;
                            break;
                        }
                    }
                    if (isCurrentPageFav)
                        $("#favourites").addClass("has-fav-already");
                    else
                        $("#favourites").removeClass("has-fav-already");
                    $("#favs-list").html(favsHtml);
                });
            },
            removeFavourite: function (id) {
                var _this = this;
                sendGATagTrackingEvent("Toolbar", "Profile Menu", "Remove Favorite", window.location.href);

                axios.delete(this.routes.favourites + "/" + id).then(function () {
                    _this.loadFavourites();
                });
            },
            showAlertLogoutMessage: function () {
                alert('Do not forget to also log out of google and close your browser if on a shared computer!');
            },
            doSearch: function (e) {
                if (e) {
                    e.preventDefault();
                }

                var term = this.search.term;
                if (term === "") {
                    alert("Please enter a search term");
                }
                else {
                    var area = getQuerystring("type");
                    if (!area) {
                        area = "All";
                    }
                    sendGATagTrackingEvent("Toolbar", "Search", term, area);
                    window.location.href = "/searchresults?type=" + area + "&term=" + term;
                }
            },
            getPopupTemplate: function () {
                var logoutRoute = $("#profileDropdown").data("logouturl");
                return "<div class='actions'>                    <div><a id='homepageLink' class='action a' href='\\#' onclick='$mainMenuVue.makeHomepage(event); return false;' title='Set this page to be what loads when you login to medportal'><i class='fal fa-fw fa-house'></i>Make this my Homepage</a></div>                    <div><a class='action a' href='/account' onclick='sendGATagTrackingEvent(\"Toolbar\", \"Profile Menu\", \"My Account\");'><i class='fal fa-fw fa-user'></i>My Account</a></div>                    <div id='favourites'><div class='action f'><i class='fal fa-fw fa-heart'></i>Favourites</div><ul id='favs-list' class='list-unstyled'></ul><div class='add' onclick='$mainMenuVue.addFavourite(); return false;''><i class='fa fa-fw fa-plus-circle'></i>Add to favourites</div></div>                    <div><a class='action s' href='/sitemap' onclick='sendGATagTrackingEvent(\"Toolbar\", \"Profile Menu\", \"Sitemap\");'><i class='fal fa-fw fa-sitemap'></i>Sitemap</a></div>                    <div><a class='action h' href='/help'  onclick='sendGATagTrackingEvent(\"Toolbar\", \"Profile Menu\", \"Help\");'><i class='fal fa-fw fa-question-circle'></i>Help</a></div>                    <div><a class='action l' href='%logoutRoute%' onclick='sendGATagTrackingEvent(\"Toolbar\", \"Profile Menu\", \"Logout\");'><i class='fa fa-fw fa-sign-out'></i>Logout</a></div >                </div>".replace("%logoutRoute%", logoutRoute);
            },
            getFavoriteTemplate: function () {
                return "# for(var i=0; i < data.length; i++){ #                    <li class='actions'>                        <a href='#: data[i].Url #' title='#: data[i].Url #'  onclick='sendGATagTrackingEvent(\"Toolbar\", \"Profile Menu\", \"Open Favorite\", \"#: data[i].PageName #\");'>                            #: data[i].PageName #                        </a>                        <i class='fa fa-minus-circle pull-right' onclick='$mainMenuVue.removeFavourite(\"#: data[i].FavouriteID #\"); return false;'></i>                    </li>                # } #";
            },
            getMobileMenuTemplate: function () {
                return "<div id='mobile-apps-menu-popup'>\
                        <div class='apps-header clearfix'>\
                            <a href='\\#' class='far fa-fw fa-times app-close pull-right theme-color' onclick='$mainMenuVue.closeMobileAppMenu(); return false;'></a>\
                        </div>\
                        <div class='medportal-apps'>\
                            # for (var i = 0; i < data.length; i++) { #\
                                <div class='mobile-app-item #= data[i].Name #'>\
                                    <a href='#= data[i].Url #' class='theme-color'\
                                        # if(data[i].Notification) { #\
                                            data-notification-key='#= data[i].Notification #'\
                                        # } #\
                                        >\
                                        <span class='icon'>#= data[i].Icon #</span>\
                                        <span class='name'>#= data[i].Name #</span>\
                                    </a>\
                                </div>\
                            # } #\
                        </div>\
                    </div>";
            }
        },
        computed: {

        },
        watch: {
        }
    });
}